import { t } from '@lingui/macro'
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { getLabelFromTranslationData } from 'app/views/common/translationsCommon'
import { pdfTableCellTextStyle, pdfTableStyles } from 'app/views/forms/pdf-components/PdfTableStyles'
import { myI18n } from 'translation/I18nConnectedProvider'

export const FormObjectivesFillablePdf = ({
  value,
  elementType,
  typeProps,
  langVersion,
  title,
  helpText,
  tooltip,
  connectedObject,
  altLabelPlacement,
  ...props
}) => {
  const { options = [] } = typeProps
  const needsHelpText = typeProps?.needsHelpText?.[langVersion]
  const outcomesHelpText = typeProps?.outcomesHelpText?.[langVersion]
  // const fundType = connectedObject
  //   ? connectedObject.RecordType.Id
  //   : STF_LP_RECORD_TYPE

  const styles = {
    ...pdfTableStyles,
    ...StyleSheet.create({
      headerCell: {
        ...pdfTableStyles.tableCol,
        ...pdfTableCellTextStyle,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'left',
        flex: 1,
        fontWeight: 'bold'
      },
      cell: {
        ...pdfTableStyles.tableCol,
        ...pdfTableCellTextStyle,
        flex: 1,
        minHeight: 35
      },
      tableRow: {
        ...pdfTableStyles.tableRow,
        flexWrap: 'nowrap',
        display: 'flex',
        width: '100%'
      }
    })
  }

  return (
    <View style={pdfTableStyles.table}>
      <View style={styles.tableRow}>
        <View style={styles.headerCell}>
          <Text>{myI18n?._(t`Objective`)}</Text>
        </View>
        <View style={{ ...styles.headerCell, flex: 2 }}>
          <Text>{myI18n?._(t`Needs`)}</Text>
          {needsHelpText && (
            <Text style={{ fontWeight: 'light', fontStyle: 'italic' }}>
              {needsHelpText}
            </Text>
          )}
        </View>
        <View style={{ ...styles.headerCell, flex: 2 }}>
          <Text>{myI18n?._(t`Outcomes`)}</Text>
          {outcomesHelpText && (
            <Text style={{ fontWeight: 'light', fontStyle: 'italic' }}>
              {outcomesHelpText}
            </Text>
          )}
        </View>
      </View>
      {options?.map((data, index) => {
        const { labels } = data
        return (
          <View style={styles.tableRow} key={index}>
            <View style={styles.cell}>
              <Text>
                {getLabelFromTranslationData({
                  data: labels,
                  langVersion
                })}
              </Text>
            </View>
            <View style={{ ...styles.cell, flex: 2 }} />
            <View style={{ ...styles.cell, flex: 2 }} />
          </View>
        )
      })}
    </View>
  )
}
